export interface Bonus {
  number: string
  title: string
  body: string
  volume: string
  image: string
  alt: string
}

export const bonuses: Bonus[] = [
  {
    number: 'Bonus 1',
    title: 'Démarrage rapide : votre premier parcours CAP™ en 14 jours',
    body: 'Pour ne pas vous perdre dans six tomes : un plan de quatorze jours qui indique quoi lire en priorité et quoi mettre en place, jusqu’à votre premier parcours structuré. Avec la fiche pour préparer chaque séance en dix minutes.',
    volume: '≈ 14 pages',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/e7807abf-5c6f-407e-a1b5-ed4eb362f920.jpg',
    alt: 'Fiche imprimée présentant un calendrier de quatorze cases',
  },
  {
    number: 'Bonus 2',
    title: 'Le Carnet du coaché',
    body: 'Un carnet prêt à imprimer à remettre à chacun de vos clients : leur point de départ, leur feuille de route, leur Journal des ancrages et leurs trois bilans, pour qu’ils constatent eux-mêmes le chemin parcouru.',
    volume: '≈ 24 pages, 9 fiches',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/1cb97b90-2a23-4ea3-aae9-599532f4a6f2.jpg',
    alt: 'Carnet ouvert montrant une feuille de route en trois jalons',
  },
  {
    number: 'Bonus 3',
    title: 'La Séance Zéro, prête à l’emploi',
    body: 'Le déroulé de 75 minutes sur une seule page, une version courte de 45 minutes, trente questions CORE classées et deux e-mails à envoyer avant et après.',
    volume: '≈ 12 pages',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/5d714cbe-1d29-4539-b828-affe3ab97695.jpg',
    alt: 'Fiche de déroulé de séance avec une ligne de temps de 75 minutes',
  },
  {
    number: 'Bonus 4',
    title: 'Le Coffre des preuves de progrès',
    body: 'Les progrès qu’on ne nomme pas s’oublient. Sept types de progrès pour les repérer, vingt phrases pour aider vos clients à les formuler, et trois fiches pour les conserver tout au long du parcours.',
    volume: '≈ 12 pages',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/18381344-e7b2-44b4-8cb3-aa17a73d6f3e.jpg',
    alt: 'Coffret ouvert contenant un jeu de fiches imprimées',
  },
  {
    number: 'Bonus 5',
    title: 'Le client qui stagne : la fiche d’urgence en 15 minutes',
    body: 'Trois questions pour identifier le type de blocage, un arbre de décision sur une page et cinq trames pour ajuster, sans forcer le client et en restant dans votre cadre.',
    volume: '≈ 14 pages',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/24bb5c47-4d8b-4786-baea-4dc41a6c9bbb.jpg',
    alt: 'Fiche imprimée montrant un tracé de chemin qui reprend une direction',
  },
]
